import axios from "axios";
import { useEffect, useState } from "react";
import { useAdminAuth } from "../../../context/AdminAuthContext";

import Breadcrumb from "../../../components/AdminSideComponents/BreadCrumb";
import BookingsReports from "../../../components/AdminSideComponents/reports/BookingsReports";
import InventoryReports from "../../../components/AdminSideComponents/reports/InventoryReports";
import SalesReports from "../../../components/AdminSideComponents/reports/SalesReports";
import StaffReports from "../../../components/AdminSideComponents/reports/StaffReports";

const Reports = () => {
  const { admin, isAdmin, isManager } = useAdminAuth();

  const [activeTab, setActiveTab] = useState("Sales");

  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [branchLoading, setBranchLoading] = useState(false);

  useEffect(() => {
    if (!isAdmin) return;

    const fetchBranches = async () => {
      try {
        setBranchLoading(true);
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/branches/get-all`,
        );
        setBranches(res.data.data || []);
      } catch (err) {
        console.error("Failed to fetch branches", err);
      } finally {
        setBranchLoading(false);
      }
    };

    fetchBranches();
  }, [isAdmin]);

  const branchId = isManager
    ? admin?.assignedBranch?._id
    : selectedBranch || undefined;

  return (
    <div className="min-h-[90vh] bg-gradient-to-br from-[#FFF7F3] to-gray-50 ">
      {/* Breadcrumb */}
      <div className="px-6 py-2">
        <Breadcrumb title1="Reports" title2={activeTab} />
      </div>

      <div className="mx-6 pb-6 space-y-6">
        {/* Branch Selector (Super Admin only) */}
        {isAdmin && (
          <div className="bg-white border rounded-lg p-2 shadow-sm">
            {branchLoading ? (
              <div className="h-10 w-32 bg-gray-200 animate-pulse rounded-md" />
            ) : (
              <div className="flex gap-2 overflow-x-auto no-scrollbar">
                <button
                  onClick={() => setSelectedBranch("")}
                  className={`px-4 py-2 rounded-md text-sm font-semibold ${
                    selectedBranch === ""
                      ? "bg-[#f0653a] text-white"
                      : "bg-gray-100 text-gray-600"
                  }`}
                >
                  All
                </button>

                {branches.map((b) => (
                  <button
                    key={b._id}
                    onClick={() => setSelectedBranch(b._id)}
                    className={`px-4 py-2 rounded-md text-sm font-semibold ${
                      selectedBranch === b._id
                        ? "bg-[#f0653a] text-white"
                        : "bg-gray-100 text-gray-600"
                    }`}
                  >
                    {b.branchName}
                  </button>
                ))}
              </div>
            )}
          </div>
        )}

        {/* Tabs */}
        <div className="flex gap-2 border-b border-[#F7BFAD]">
          {["Sales", "Bookings", "Staff"].map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-5 py-2.5 text-sm font-semibold rounded-t-md ${
                activeTab === tab
                  ? "bg-white text-[#f0653a] border border-b-0 border-[#F7BFAD]"
                  : "text-gray-500 hover:text-[#f0653a]"
              }`}
            >
              {tab}
            </button>
          ))}

          {/* Inventory — Super Admin only */}
          {isAdmin && (
            <button
              onClick={() => setActiveTab("Inventory")}
              className={`px-5 py-2.5 text-sm font-semibold rounded-t-md ${
                activeTab === "Inventory"
                  ? "bg-white text-[#f0653a] border border-b-0 border-[#F7BFAD]"
                  : "text-gray-500 hover:text-[#f0653a]"
              }`}
            >
              Inventory
            </button>
          )}
        </div>

        {/* Tab Content */}
        {activeTab === "Sales" && <SalesReports branchId={branchId} />}
        {activeTab === "Bookings" && <BookingsReports branchId={branchId} />}
        {activeTab === "Staff" && <StaffReports branchId={branchId} />}

        {/* Inventory — Hard Guarded */}
        {isAdmin && activeTab === "Inventory" && (
          <InventoryReports branchId={branchId} />
        )}
      </div>
    </div>
  );
};

export default Reports;
